import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { ActionService } from 'src/app/core/services/action.service';
import { RouteService } from 'src/app/core/services/route.service';
import { PutData } from 'src/app/core/state/_actions/form.actions';
import { OpTypes } from 'src/app/core/state/_models/general.model';
import { getFormOperations } from 'src/app/core/state/_selectors/form.selector';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-upsert-location',
  templateUrl: './upsert-location.component.html',
  styleUrls: ['./upsert-location.component.scss'],
})
export class UpsertLocationComponent implements OnInit {
  @Input('inputProp') inputProp: any;
  @Input('tableId') tableId: any;
  @Input('reportsData') reportsData: any;
  @Input('mapReportData') mapReportData: any;
  @Input('pinId') pinId: any;
  @Input('iconColor') iconColor: string = 'blue';
  @Input('marker') marker: string = '/assets/images/custom-markers/mapbox-marker-purple.png';
  @Input('isCustomColor') isCustomColor: boolean = false;
  @Input('isLimitExceed') isLimitExceed: boolean = false;
  @Output('closeModal') closeModal = new EventEmitter<void>()
  editLink: string = '';

  constructor(
    private modal: NgbModal,
    private fb: UntypedFormBuilder,
    private store: Store,
    private route: RouteService,
    private action: ActionService,
    private alert: AlertService
  ) {}
  form!: UntypedFormGroup;
  ngOnInit(): void {
    this.initForm();
    this.setValues();
    this.editLink = `apps/${this.route.getApplicationKey()}/tables/${
      this.tableId
    }/reports/datatable/view/${this.reportsData?.Key}/details/${
      this.inputProp?.Id
    }`;
  }

  ngOnChanges(changes:SimpleChanges){
    if(changes.inputProp.currentValue !== changes.inputProp.previousValue){
      this.setValues();
    }
  }

  getIconColor(){
    return !this.isLimitExceed ? (this.isCustomColor ? this.iconColor : (this.marker.split('/') as any).at(-1).split('-').at(-1).split('.')[0]) : 'blue';
  }

  /**
   * Close modal
   */
  close = () => {
    this.closeModal.emit();
  };
  onSubmit = async () => {
    let payload = {
      ApplicationTableId: this.tableId,
      FieldsList: [
        {
          Name: this.reportsData.NameFieldData.fieldName,
          Value: this.form.controls['Name'].value,
          Base64EncodedFile: '',
          DropdownValues: [],
          FileUrl: '',
          Type: this.reportsData.NameFieldData.FieldType,
          Id: this.reportsData.NameFieldData.Id,
        },
        {
          Name: this.reportsData.DescriptionFieldData.fieldName,
          Value: this.form.controls['Description'].value,
          Base64EncodedFile: '',
          DropdownValues: [],
          FileUrl: '',
          Type: this.reportsData.DescriptionFieldData.FieldType,
          Id: this.reportsData.DescriptionFieldData.Id,
        },
        {
          Name: this.reportsData.LatitudeFieldData.fieldName,
          Value: this.form.controls['Latitude'].value,
          Base64EncodedFile: '',
          DropdownValues: [],
          FileUrl: '',
          Type: this.reportsData.LatitudeFieldData.FieldType,
          Id: this.reportsData.LatitudeFieldData.Id,
        },
        {
          Name: this.reportsData.LongitudeFieldData.fieldName,
          Value: this.form.controls['Longitude'].value,
          Base64EncodedFile: '',
          DropdownValues: [],
          FileUrl: '',
          Type: this.reportsData.LongitudeFieldData.FieldType,
          Id: this.reportsData.LongitudeFieldData.Id,
        },
      ],
    };
    if (this.reportsData.PrimaryDescriptionFieldData) {
      payload.FieldsList.push({
        Name: this.reportsData.PrimaryDescriptionFieldData.fieldName,
        Value: this.form.controls['PrimaryDescription'].value,
        Base64EncodedFile: '',
        DropdownValues: [],
        FileUrl: '',
        Type: this.reportsData.PrimaryDescriptionFieldData.FieldType,
        Id: this.reportsData.PrimaryDescriptionFieldData.Id,
      });
    }
    if (this.reportsData.SecondaryDescriptionFieldData) {
      payload.FieldsList.push({
        Name: this.reportsData.SecondaryDescriptionFieldData.fieldName,
        Value: this.form.controls['SecondaryDescription'].value,
        Base64EncodedFile: '',
        DropdownValues: [],
        FileUrl: '',
        Type: this.reportsData.SecondaryDescriptionFieldData.FieldType,
        Id: this.reportsData.SecondaryDescriptionFieldData.Id,
      });
    }
    await this.action.dispatch(
      OpTypes.UPDATE,
      new PutData(this.form.controls['Id'].value, this.tableId, {
        ...(<any>payload),
        Where: {
          Rid: this.form.controls['Id'].value,
        },
      }),
      getFormOperations
    );
    this.close();
  };

  /**
   * Init form
   */
  initForm = () => {
    this.form = this.fb.group({
      Id: [null],
      Name: [null],
      Description: [null],
      Latitude: [null],
      Longitude: [null],
      PrimaryDescription: [null],
      SecondaryDescription: [null],
    });
  };

  setValues = () => {
    this.form?.patchValue({ ...this.inputProp });
  };

  getIdPosition(id:number){
    if(id.toString().length < 3) return '20%'
    else if(id.toString().length < 7) return '30%'
    else return '35%'
  }
}
